'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callIfPossible = callIfPossible;
exports.sequence = sequence;
exports.memoizedSequence = memoizedSequence;
exports.stackRefs = stackRefs;
exports.wrapRefObject = wrapRefObject;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function callIfPossible(prop) {
  if (typeof prop !== 'function') {
    return prop;
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return prop.apply(undefined, args);
}

function sequence() {
  for (var _len2 = arguments.length, handlers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    handlers[_key2] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    handlers.forEach(function (handler) {
      return typeof handler === 'function' && handler.apply(undefined, args);
    });
  };
}

var sequenceCache = void 0;
var resultKey = {};

function memoizedSequence() {
  for (var _len4 = arguments.length, handlers = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    handlers[_key4] = arguments[_key4];
  }

  if (handlers.length === 1) return handlers[0];
  handlers = handlers.filter(function (handler) {
    return handler != null;
  });

  /* eslint-disable no-restricted-globals */

  // WeakMap *should* exist, but just to be sure...
  if (!window.WeakMap) return sequence.apply(undefined, _toConsumableArray(handlers));

  // If this sequence has been generated before, return it
  var cache = sequenceCache;
  handlers.forEach(function (handler) {
    cache = cache && cache.get(handler);
  });
  if (cache instanceof WeakMap && cache.has(resultKey)) return cache.get(resultKey);

  // Otherwise, generate a new sequence and save it in the cache
  var newSequence = sequence.apply(undefined, _toConsumableArray(handlers));
  if (sequenceCache === undefined) sequenceCache = new WeakMap();

  cache = sequenceCache;
  handlers.forEach(function (handler) {
    if (!(cache.get(handler) instanceof WeakMap)) {
      cache.set(handler, new WeakMap());
    }
    cache = cache.get(handler);
  });
  cache.set(resultKey, newSequence);
  return newSequence;

  /* eslint-enable no-restricted-globals */
}

function stackRefs(componentName, originalRef) {
  if (typeof originalRef === 'string') {
    _devLogger2.default.warn({
      message: componentName + ': Child ref is a string, which prevents additional refs. Please use a callback ref.',
      key: componentName + ': string ref'
    });
    return originalRef;
  }

  for (var _len5 = arguments.length, extraRefs = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    extraRefs[_key5 - 2] = arguments[_key5];
  }

  return memoizedSequence.apply(undefined, extraRefs.concat([originalRef]));
}

var wrapRefObjectCache = void 0;

var makeCallbackForRefObject = function makeCallbackForRefObject(ref) {
  return function (el) {
    ref.current = el;
  };
};

/**
 * Returns a callback wrapper around the given ref object if the current version of React does not
 * support ref objects. If ref objects are supported, it returns the ref object itself.
 *
 * @param {Object} ref
 */
function wrapRefObject(ref) {
  if (ref == null || typeof _react2.default.createRef === 'function') return ref;

  /* eslint-disable no-restricted-globals */

  // WeakMap *should* exist, but just to be sure...
  if (!window.WeakMap) return makeCallbackForRefObject(ref);

  if (wrapRefObjectCache === undefined) wrapRefObjectCache = new WeakMap();
  if (wrapRefObjectCache.has(ref)) return wrapRefObjectCache.get(ref);
  var callback = makeCallbackForRefObject(ref);
  wrapRefObjectCache.set(ref, callback);
  return callback;

  /* eslint-enable no-restricted-globals */
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/core/Functions.js
// module id = 2
// module chunks = 0